const { Cycler } = window.BAO
const { getElements } = window.BAO.Utils
const Papa = window.Papa

class SizeGuide extends window.BAO.CustomElement() {
  CURRENT_SIZE_ATTRIBUTE = 'current-size'
  ALLOWED_SIZES = ['cm', 'in']
  CLASSES = {
    cm: 'drw-SizeGuide-cm',
    in: 'drw-SizeGuide-in',
  }

  connectedCallback () {
    this.cycler = new Cycler(this.ALLOWED_SIZES)
    this.cycler.set(this.cycler.items.findIndex((i) => i === this.currentSize))

    this.fetchTable()
    this.fetchMeasurement()

    if (!this.els.trigger?.exists) return

    this.handleTriggerClick = this.handleTriggerClick.bind(this)
    this.els.trigger?.element.addEventListener(
      'click',
      this.handleTriggerClick,
      {
        passive: true,
      },
    )
  }

  disconnectedCallback () {
    if (!this.els.trigger?.exists) return

    this.els.trigger?.element.removeEventListener(
      'click',
      this.handleTriggerClick,
    )
  }

  fetchTable () {
    const tableContent = this.els.table.element.getAttribute('data-table')

    if (!tableContent) return

    Papa.parse(tableContent, {
      download: true,
      header: true,
      slipEmptyLines: true,
      complete: (results) => {
        const rows = results?.data
        const headingFields = results?.meta.fields

        const table = document.createElement('table')
        table.classList.add('rte-RichText_Table')

        let rowIndex = 0

        if (headingFields) {
          const tr = document.createElement('tr')

          headingFields.forEach((cell, colIndex) => {
            const td = document.createElement('td')
            td.setAttribute('data-value', cell.trim())
            td.textContent = cell.trim()
            td.dataset.row = rowIndex
            td.dataset.col = colIndex
            tr.appendChild(td)
          })

          table.appendChild(tr)

          rowIndex = rowIndex + 1
        }

        rows.forEach((row) => {
          const rowValues = Object.values(row)

          // move text cell to first
          const nonNumericalValue = rowValues.find((item) => isNaN(item))
          const index = rowValues.indexOf(nonNumericalValue)

          if (index > -1) {
            rowValues.splice(index, 1)
            rowValues.unshift(nonNumericalValue)
          }

          const tr = document.createElement('tr')

          rowValues.forEach((cell, colIndex) => {
            const td = document.createElement('td')
            if (
              colIndex !== 0 &&
              this.els.table.element.dataset.convert === 'true'
            ) {
              td.setAttribute('data-integer', cell.trim())
              td.setAttribute('data-size-guide-el', 'integer')
            }
            td.setAttribute('data-value', cell.trim())
            td.textContent = cell.trim()
            td.dataset.row = rowIndex
            td.dataset.col = colIndex
            tr.appendChild(td)
          })

          rowIndex = rowIndex + 1

          table.appendChild(tr)
        })

        this.els.table.element.appendChild(table)

        table.querySelectorAll('td').forEach((cell) => {
          cell.addEventListener('mouseenter', function () {
            const rowIndex = parseInt(this.dataset.row, 10)
            const colIndex = parseInt(this.dataset.col, 10)

            if (colIndex === 0) return

            table
              .querySelectorAll(`tr:nth-child(${parseInt(rowIndex) + 1}) td`)
              .forEach((el) => el.classList.add('rte-RichText_Cell-active'))

            table
              .querySelectorAll(`td[data-col='${colIndex}']`)
              .forEach((el) => el.classList.add('rte-RichText_Cell-active'))
          })

          cell.addEventListener('mouseleave', () => {
            table
              .querySelectorAll('.rte-RichText_Cell-active')
              .forEach((el) => el.classList.remove('rte-RichText_Cell-active'))
          })

          cell.addEventListener('click', (cell) =>
            this.onCellClick(cell, this.els.table.element),
          )

          if (this.hasAttribute('data-option')) {
            this.findMatchingColumn(
              this.dataset.option,
              this.els.table.element,
            )
          }
        })
      },
      error: (error) => {
        console.error('Error loading CSV:', error)
        this.els.table.element.textContent = 'Could not load table.'
      },
    })
  }

  fetchMeasurement () {
    const tableContent =
      this.els.measurement?.element.getAttribute('data-table')

    if (!tableContent) return

    fetch(tableContent)
      .then((response) => response.text())
      .then((text) => {
        const rows = text
          .trim()
          .split('\n')
          .map((r) => r.split(','))

        const maxCols = Math.max(...rows.map((r) => r.length))
        const transposed = []
        for (let c = 0; c < maxCols; c++) {
          const col = []
          for (let r = 0; r < rows.length; r++) {
            col.push(rows[r][c] || '')
          }

          transposed.push(col)
        }

        const table = document.createElement('table')
        table.classList.add('rte-RichText_Table')

        transposed.forEach((row, rowIndex) => {
          const tr = document.createElement('tr')

          row.forEach((cell, colIndex) => {
            const td = document.createElement('td')
            if (colIndex !== 0) {
              td.setAttribute('data-integer', cell.trim())
              td.setAttribute('data-size-guide-el', 'integer')
            }
            td.setAttribute('data-value', cell.trim())
            td.textContent = cell.trim()
            td.dataset.row = rowIndex
            td.dataset.col = colIndex
            tr.appendChild(td)
          })

          table.appendChild(tr)
        })

        this.els.measurement.element.appendChild(table)

        if (this.hasAttribute('data-option')) {
          this.hideColumn(this.dataset.option, this.els.measurement.element)
        }
      })
      .catch((err) => {
        console.error('Error loading CSV:', err)
        this.els.table.element.textContent = 'Could not load table.'
      })
  }

  onCellClick (e, table) {
    const cellIndex = e?.currentTarget?.cellIndex

    if (cellIndex === 0 || !table) return

    getElements('td', { context: table }).forEach((el) =>
      el.classList.toggle(
        'drw-SizeGuide_Table-columnHighlight',
        el.cellIndex === cellIndex,
      ),
    )

    const matchingHeading = getElements('td', { context: table }).filter(
      (el) => el.closest('tr').rowIndex === 0 && el.cellIndex === cellIndex,
    )

    if (!matchingHeading.length) return

    let variantTitleStripped = matchingHeading[0]?.dataset?.value
      ?.trim()
      .toLowerCase()
    if (this.tableHeadingsFormat !== this.variantsFormat) {
      variantTitleStripped = matchingHeading[0]?.dataset?.convertedValue
        ?.trim()
        .toLowerCase()
    }

    const optionSelector = getElements(
      '.prd-Options_Option [data-variant-radios-el="option-choice"]',
    )

    const matchingOptions = Array.from(optionSelector).filter(
      (el) => el?.value?.trim()?.toLowerCase() === variantTitleStripped,
    )

    if (matchingOptions.length) {
      matchingOptions.forEach((option) => option.click())
    }

    this.dataset.option = matchingHeading[0].dataset.value
    this.els.title?.element.classList.remove('drw-SizeGuide_Title-hide')
    this.els.measurement?.element.classList.remove('drw-SizeGuide_Table-hide')

    if (this.hasAttribute('data-option')) {
      this.hideColumn(this.dataset.option, this.els.measurement?.element)
    }
  }

  findMatchingColumn (option, table) {
    const variantTitle = option.trim()
    const variantTitleStripped = variantTitle.toLowerCase()

    if (!table) return

    const cellIndex = getElements('td', { context: table }).findIndex(
      (el) => el?.dataset.value?.trim().toLowerCase() === variantTitleStripped,
    )

    if (cellIndex === -1) return

    getElements('td', { context: table }).forEach((el) =>
      el.classList.toggle(
        'drw-SizeGuide_Table-columnHighlight',
        el.cellIndex === cellIndex,
      ),
    )
  }

  hideColumn (option, table) {
    const variantTitle = option.trim()
    const variantTitleStripped = variantTitle.toLowerCase()

    if (!table) return

    const cellIndex = getElements('td', { context: table }).findIndex(
      (el) => el?.dataset.value?.trim().toLowerCase() === variantTitleStripped,
    )

    if (cellIndex === -1) return

    getElements('td[data-size-guide-el="integer"]', { context: table }).forEach(
      (el) =>
        el.classList.toggle(
          'drw-SizeGuide_Table-hide',
          el.cellIndex !== cellIndex,
        ),
    )
  }

  async handleTriggerClick () {
    const currentSize = this.cycler.next()

    this.setCartAttribute(currentSize)
    this.currentSize = currentSize
    this.syncThemeSwitchers(currentSize)

    window.BAO.eventBus.dispatchEvent(window.BAO.EVENTS.THEME_SWITCH, {
      currentSize,
    })

    if (currentSize === 'cm') {
      this.els.integer.elements.forEach((integerEl) => {
        const inValue = integerEl.dataset.integer
        integerEl.innerText = inValue
      })
    } else {
      this.els.integer.elements.forEach((integerEl) => {
        const cmValue = (integerEl.dataset.integer / 2.54).toFixed(1)
        integerEl.innerText = cmValue
      })
    }
  }

  syncThemeSwitchers (currentSize) {
    this.allOtherThemeSwitches.forEach((el) => {
      el.currentSize = currentSize
      el.cycler.next()
    })
  }

  setCartAttribute (size) {
    // eslint-disable-next-line compat/compat
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          current_size: size,
        },
      }),
    })
  }

  get currentSize () {
    return (
      this.getAttribute(this.CURRENT_SIZE_ATTRIBUTE) || this.ALLOWED_SIZES[0]
    )
  }

  set currentSize (value) {
    this.setAttribute(this.CURRENT_SIZE_ATTRIBUTE, value)

    this.classList.toggle(this.CLASSES.in, value === 'in')
    this.classList.toggle(this.CLASSES.cm, value === 'cm')
  }

  get allOtherThemeSwitches () {
    // eslint-disable-next-line compat/compat
    return Array.from(document.querySelectorAll(this.localName)).filter(
      (el) => el !== this,
    )
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
